import React from "react";
import logo from "../../assets/logoavena.jpg"; // adjust the path as needed

export default function CareerRow({ item, onEdit, onDelete }) {
  const posted = item.posted_at ? new Date(item.posted_at).toLocaleDateString() : "";
  const deadline = item.deadline_at ? new Date(item.deadline_at).toLocaleDateString() : "";

  return (
    <div className="job-row">
      <div className="job-row__media">
        <img
          src={logo}
          alt="Company Logo"
          loading="lazy"
          className="job-row__logo"
        />
      </div>

      <div className="job-row__main">
        <div className="job-row__topline">
          <h3 className="job-row__title">{item.title}</h3>
          <div className="job-row__chips">
            {item.employment_type && <span className="chip">{item.employment_type}</span>}
            {item.level && <span className="chip chip--muted">{item.level}</span>}
            {item.category && <span className="chip chip--muted">{item.category}</span>}
          </div>
        </div>

        {item.excerpt && <p className="job-row__excerpt">{item.excerpt}</p>}

        <div className="job-row__meta">
          {posted && <span>Posted: {posted}</span>}
          {posted && deadline && <span className="dot">•</span>}
          {deadline && <span>Deadline: {deadline}</span>}
        </div>
      </div>

      <div className="job-row__actions">
        <button className="btn btn--ghost" onClick={() => onEdit(item)}>Edit</button>
        <button className="btn btn--danger" onClick={() => onDelete(item.id)}>Delete</button>
      </div>
    </div>
  );
}
